module.exports = __webpack_public_path__ + "img/drop-down-gray.0898296c.svg";